export const footerRedirect = [
    { text: "Terms of Use", url: "https://taxportal.rsmus.com/taxportal/opresource.action?res=49a56a49i52c55e57e52&optype=2" },
    { text: "Privacy", url: "https://rsmus.com/pages/rsm-us-privacy-policy.html" },
    { text: "Contact", url: "https://rsmus.com/contact.html" },
    { text: "Cookies", url: "https://rsmus.com/pages/rsm-us-privacy-policy.html#cookies" },
  ];